import { apiService } from '@/services/APIService';

const PATH = '/regions/significances';

export default {
  // from CRUD

  getAll(params) {
    return apiService.get(PATH, params);
  },

  get(id, params) {
    return apiService.get(`${PATH}/${id}`, params);
  },

  create(payload) {
    return apiService.post(PATH, payload);
  },

  update(id, payload) {
    return apiService.put(`${PATH}/${id}`, payload);
  },

  delete(id) {
    return apiService.delete(`${PATH}/${id}`);
  },

  deleteAll(payload) {
    return apiService.delete(PATH, payload);
  },
};
